import { AppConfigConstant } from "./AppConfig";
export const BlankString: string = "";
export const ApplicationName = "Golden Phoenix";
export const LogoUrl = `${process.env.PUBLIC_URL}/images/logo.png`;
export const API_URL: string = `${AppConfigConstant.API_URL}`;
export const WORKER_JS : string = `${process.env.PUBLIC_URL}/javascript/pdf.worker.min.js`;
export const APPLICATION_PDF = "application/pdf";
export const BASE64 = "base64";
export const TIMER_ZERO : number = 0;
export const MOBILE_DEVICES: string = "only screen and (max-width: 991px)";
export const BTN_SMALL_LOADER: number = 38;
export const PWD_PATTERN: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

export const loginFormLabelsText = {
  username: "Registered Email / Mobile Number",
  usernameInputError: "Registered Email / Mobile Number is required",
  password: "Password",
  passwordInputError: "Password is required"
};

export const AuthenticationConstans = {
  Identity: "IDENTITY"
};

export const HTTPStatusCodes = {
  OK: 200,
  NotAcceptable: 406,
  UnAuthorized: 401,
  InternalServerError: 500,
  Forbidden: 403,
  BadRequest: 400,
  Created: 201
};

export const ErrorMessages = {
  NetworkError: "Network error, please try again by reloading page",
  InernalServerError: "Internal server error, please try again later",
  InvalidEmail: "This is not a valid email address",
  ExpiredToken: "Your token is expired, login again to continue",
  Forbidden: "You are not allowed to perform this action"
};

export const EmailStatusMessages = {
  MailSentSucessfully: "Mail has been sent to agent successfully",
  MailSendingInfo: "Please wait... sending registration link to agent",
  InvalidEmail: "This is not a valid email address",
  InvalidFormDetails: "Form fields are invalid, correct them and submit"
};

export const HttpRequestMethods = {
  POST: "POST",
  GET: "GET",
  PATCH: "PATCH",
  PUT: "PUT"
};

export const Roles = {
  ADMIN: "Admin",
  AGENT: "Agent",
  MANAGER: "Manager"
}

export const MenuId = {
  DASHBOARD: 1,
  RESOURCES: 2,
  FORMS_AND_DOCS: 21,
  TRAINING_VIDEOS: 22,
  ABOUT: 3,
  AGENTS: 4,
  AGENTS_SEND_REGISTRATION: 41,
  AGENTS_LIST: 42,
  AGENT_PROFILE: 421,
  LOGIN: 5,
  FORGOT_PASSWORD: 50,
  RESET_PASSWORD: 51,
  REGISTER_TOKENID: 6,
  REGISTER_SUCCESS: 61,
  FAQ: 7,
  AGENT_TOOLS: 8,
  PRODUCTIONS: 81,
  FNA: 82
}
